// Conversation Status Utilities
// Provides helpers for timestamp derivation and related calculations

import { Activity } from '../types';

// Minimal shape for entities carrying timestamps we care about
export type TimestampSource = {
    type?: string;
    name?: string;
    timestamp?: string | number | Date;
    localTimestamp?: string | number | Date;
    value?: { timestamp?: string | number | Date };
};

// Return the timestamp (in epoch milliseconds) for the most relevant time associated with the given entity.
export const toEpochMs = (
    entity: TimestampSource | null | undefined
): number | null => {
    if (!entity) return null;
    let ts: string | number | Date | undefined = undefined;
    // Prefer the timestamp set on the event for userWaiting events
    // The timestamp set on the event captures the time the lastMessage that triggered
    // the userWaiting message was sent, rather than when the event activity itself was created
    if (entity?.type === 'event' && entity?.name === 'userWaiting') {
        ts = entity?.value?.timestamp;
    }
    // Fallback to standard timestamp
    if (!ts) ts = entity?.timestamp;
    // Then local timestamp, if present
    if (!ts) ts = entity?.localTimestamp;
    if (!ts) return null;
    const n = new Date(ts).getTime();
    return Number.isNaN(n) ? null : n;
};

export const isUserWaitingEvent = (activity: Activity): boolean => {
    return activity?.type === 'event' && activity?.name === 'userWaiting';
};
